// src/hooks/useAgentStatus.js
import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { authReady } from './auth/tokenCache'; // ajuste o caminho se necessário

export function useAgentStatus(refreshTrigger) {
  const [agentStatus, setAgentStatus] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true; // <- para evitar setState depois de desmontar

    const fetchStatus = async () => {
      setIsLoading(true);
      setError(null);

      try {
        await authReady(); // só prossegue depois que user existe/null
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) throw new Error('Missing token');

        const idToken = await user.getIdToken();
        if (!idToken) throw new Error('Missing token');

        const baseUrl = process.env.REACT_APP_API_SUPORTE_URL;
        const fullUrl = `${baseUrl}/agentes/status`;

        let response = await fetch(fullUrl, {
          headers: { Authorization: `Bearer ${idToken}` },
        });

        if (response.status === 401) {
          const refreshed = await user.getIdToken(true);
          response = await fetch(fullUrl, {
            headers: { Authorization: `Bearer ${refreshed}` },
          });
        }

        if (!response.ok)
          throw new Error('A resposta da rede falhou ao buscar status');

        const responseData = await response.json();
        if (!responseData.success || !responseData.data?.agents) {
          throw new Error('O formato da resposta da API de status é inválido');
        }

        const agentList = responseData.data.agents;
        const statusMap = agentList.reduce((acc, agent) => {
          acc[agent.uid] = agent.isOnline;
          return acc;
        }, {});

        if (isMounted) setAgentStatus(statusMap);
      } catch (err) {
        if (isMounted) {
          console.error('Erro detalhado ao buscar status dos agentes:', err);
          setError(err.message);
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchStatus();

    return () => {
      isMounted = false;
    };
  }, [refreshTrigger]);

  return { agentStatus, isLoadingStatus: isLoading, statusError: error };
}
